module.exports = __webpack_public_path__ + "static/media/event16.1d97e11f.jpeg";